import { z } from 'zod';

const DeviceTypeDef = [
    'Yarn Gateway',
    'Yarn Relay',
    'Weather Station',
    'Personal Locator Beacon',
    'Trail Cam',
    'Trap Box',
    'Level Monitor',
] as const;

export const DeviceTypesWithNoLocationOverride: DeviceType[] = [
    'Personal Locator Beacon',
    'Level Monitor',
];

export type DeviceType = (typeof DeviceTypeDef)[number];

export const deviceTypeSchema = z.enum(DeviceTypeDef);
